<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-default py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="text-center" style="margin-bottom: -50px">
              <h1 class="text-white">
                SIVO
              </h1>
              <p class="text-lead text-white">
                ¡Si voy. Con SIVO!
              </p>
            </div>
            <!--
            <div class="text-white">
              <h3 class="text-white">
                <strong>You can log in with 3 user types:</strong>
              </h3>
              <div>
                Username <b>admin@jsonapi.com</b> Password <b>secret</b>
              </div>
              <div>
                Username <b>creator@jsonapi.com</b> Password <b>secret</b>
              </div>
              <div>
                Username <b>member@jsonapi.com</b> Password <b>secret</b>
              </div>
            </div>
            -->
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-primary border-0 mb-0">
            <div class="card-header bg-default pb-3">
              <div class="text-primary text-center mt-1 mb-2">
                <small>Sistema Integral de Venta Online</small>
              </div>
              <!--
              <div class="btn-wrapper text-center">
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"
                    ><img src="/img/icons/common/github.svg"
                  /></span>
                  <span class="btn-inner--text">Github</span>
                </a>
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"
                    ><img src="/img/icons/common/google.svg"
                  /></span>
                  <span class="btn-inner--text">Google</span>
                </a>
              </div>
              -->
            </div>
            <div class="card-body px-lg-5 py-lg-4">
              <div class="text-center text-muted mb-4">
                <small>Iniciar sesión para continuar</small>
              </div>
              <form role="form" @submit.prevent="handleSubmit()">
                <base-input
                  alternative
                  class="mb-3"
                  name="Username"
                  prepend-icon="ni ni-single-02"
                  placeholder="Username"
                  v-model="username"
                />
                <validation-error :errors="apiValidationErrors.email" />

                <base-input
                  alternative
                  class="mb-3"
                  name="Password"
                  prepend-icon="ni ni-lock-circle-open"
                  type="password"
                  placeholder="Password"
                  v-model="password"
                >
                </base-input>
                <validation-error :errors="apiValidationErrors.password" />
                <span v-if="error != null">
                  <small class="argon-error" v-text="error"/>
                </span>

                <div class="text-center">
                  <base-button type="primary" native-type="submit" class="my-4"
                    >Iniciar sesión</base-button
                  >
                </div>
                <!--
                <h1 class="argon-error">{{ device_id }}</h1>
                -->
              </form>
            </div>
          </div>
          <div class="row mt-3">
          <!--
            <div class="col-6">
	            <router-link :to="{ name: 'PasswordReset'}" class="text-light"><small>¿Olvidaste tu contraseña?</small></router-link>
            </div>
            
            <div class="col-6 text-right">
              <a href="/register" class="text-light"
                ><small>Crear nueva cuenta</small></a
              >
            </div>
            -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
import axios from 'axios';
export default {
  components: {
    ValidationError,
  },
  mixins: [formMixin],
  data: () => ({
    username: "",
    password: "",
    error: null,
    device_id: null,
    device_type: null
  }),
  computed: {
    isAuthenticated: function () {
      return this.$store.getters.isAuthenticated();
    },
  }, 
  mounted() {
    this.device_id = this.$route.query.device_id;
    //Indica si es: 1 MAC ADDRESS, 2 ANDROID ID
    if (this.device_id) {
      this.device_type = 2;
    }else{
      this.getMAC();
    }
  },
  methods: {
    async getMAC(){
      const options = {
        headers: {
          'Accept': 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
        }
      };
      return axios.get(`http://localhost:8002/obtenerClaveMAC`, options)
      .then(response => {
        this.device_type = 1;
        this.device_id = response.data;
      });
    },
    async handleSubmit() {
      const user = {
        data: {
          type: "token",
          attributes: {
            username: this.username,
            password: this.password,
            claveDispositivo: this.device_id,
            tipo: this.device_type
          },
        },
      };
      const requestOptions = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };
      this.error = null;

      try {
        await this.$store.dispatch("login", { user, requestOptions });
        this.resetApiValidation();
      } catch (error) {
        console.log(error)
        if(error.response.data.error){
          this.error = error.response.data.error;
        }
        if(error.response.data.errors[0]){
          this.$notify({
            type: "danger",
            message: error.response.data.errors[0].detail,
            duration: -1
          });
        }
        this.resetApiValidation();
        //this.setApiValidation(error.response.data.errors);
      }
    },
  },
};
</script>
<style lang="scss">
    .argon-error {
      position: relative;
      bottom: 25px !important;
      color: #fb6340;
      }
  
</style>